import { Combobox, type ComboboxOption } from '@library/components/selects';
import type {
  MemberPromotionFiltersParam,
  MemberPromotionFilters as MemberPromotionFiltersType
} from '@library/types/members/memberPromotions';
import { ResetIconButton } from '@library/components/buttons';
import { useMemo } from 'react';

export interface MemberPromotionFiltersProps {
  memberPromotionFilters: MemberPromotionFiltersType;
  memberPromotionTypes: Array<ComboboxOption>;
  onChangeMemberPromotionsFilter: ({
    key,
    value
  }: MemberPromotionFiltersParam) => void;
  onResetMemberPromotionFilters: () => void;
}

export const MemberPromotionFilters = ({
  memberPromotionFilters,
  memberPromotionTypes,
  onChangeMemberPromotionsFilter,
  onResetMemberPromotionFilters
}: MemberPromotionFiltersProps) => {
  const { promotionType } = memberPromotionFilters;

  const promotionTypeOption = useMemo(() => {
    return (
      memberPromotionTypes.find(({ value }) => value === promotionType) ?? null
    );
  }, [memberPromotionTypes, promotionType]);

  return (
    <div className="flex flex-wrap items-center gap-4 pb-4">
      <div className="shrink-0 basis-56">
        <Combobox
          id="promotion-type"
          isMulti={false}
          value={promotionTypeOption}
          placeholder="Promotion Type"
          onChange={(option: ComboboxOption | null) =>
            onChangeMemberPromotionsFilter({
              key: 'promotionType',
              value: option?.value as string
            })
          }
          options={memberPromotionTypes}
          closeMenuOnSelect
          valueClassName="py-[11px]"
        />
      </div>
      <ResetIconButton
        className="disabled:text-soClean-140 !m-0 shrink-0 basis-28 !p-0"
        disabled={false}
        label="Reset Filters"
        onClick={onResetMemberPromotionFilters}
      />
    </div>
  );
};
